import React from 'react';

// eslint-disable-next-line no-unused-vars
const style = {
  a: {
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 2,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
  },
};
export default function SvgMonitorIcon(props) {
  return (
    <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        d="M19 2H5C4.20435 2 3.44129 2.31607 2.87868 2.87868C2.31607 3.44129 2 4.20435 2 5V15C2 15.7956 2.31607 16.5587 2.87868 17.1213C3.44129 17.6839 4.20435 18 5 18H7.64L7.06 19C6.88446 19.304 6.79205 19.6489 6.79205 20C6.79205 20.3511 6.88446 20.696 7.06 21C7.23705 21.3067 7.49235 21.5609 7.79982 21.7366C8.10729 21.9123 8.45589 22.0032 8.81 22H15.27C15.6207 21.9996 15.9652 21.9071 16.2688 21.7315C16.5725 21.556 16.8246 21.3037 17 21C17.1755 20.696 17.268 20.3511 17.268 20C17.268 19.6489 17.1755 19.304 17 19L16.41 18H19C19.7956 18 20.5587 17.6839 21.1213 17.1213C21.6839 16.5587 22 15.7956 22 15V5C22 4.20435 21.6839 3.44129 21.1213 2.87868C20.5587 2.31607 19.7956 2 19 2ZM8.77 20L10 18H14L15.2 20H8.77ZM20 15C20 15.2652 19.8946 15.5196 19.7071 15.7071C19.5196 15.8946 19.2652 16 19 16H5C4.73478 16 4.48043 15.8946 4.29289 15.7071C4.10536 15.5196 4 15.2652 4 15V14H20V15ZM20 12H4V5C4 4.73478 4.10536 4.48043 4.29289 4.29289C4.48043 4.10536 4.73478 4 5 4H19C19.2652 4 19.5196 4.10536 19.7071 4.29289C19.8946 4.48043 20 4.73478 20 5V12Z"
        fill="#202020" />
    </svg>
  );
}
